/**
 * 埋点事件类型常量
 */

// ==================== 业务事件 ====================

/** 渠道访问 - 访问官网首页 */
export const CHANNEL_VISIT = 'CHANNEL_VISIT';

/** 落地页访问 - 官网首页停留时长>3秒或触发页面交互 */
export const LANDING_VISIT = 'LANDING_VISIT';

// ==================== 系统事件 ====================

/** 登录 - 用户成功登录时 */
export const LOGIN = 'LOGIN';

/** 注册 - 用户填写注册信息并提交时 */
export const REGISTER = 'REGISTER';

// ==================== 事件类型集合 ====================

/** 所有业务事件类型 */
export const BUSINESS_EVENTS = [
  CHANNEL_VISIT,
  LANDING_VISIT,
] as const;

/** 所有系统事件类型 */
export const SYSTEM_EVENTS = [LOGIN, REGISTER] as const;

/** 所有事件类型 */
export const ALL_EVENTS = [...BUSINESS_EVENTS, ...SYSTEM_EVENTS] as const;

// 导入类型
import type { EventType } from './types';

// ==================== 事件名称映射 ====================

/** 事件类型中文名称映射 */
export const EVENT_TYPE_NAMES: Record<EventType, string> = {
  [CHANNEL_VISIT]: '渠道访问',
  [LANDING_VISIT]: '落地页访问',
  [LOGIN]: '登录',
  [REGISTER]: '注册',
};
